/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener("DOMContentLoaded", function(event) {
  var prodouct_description = document.querySelector(".ProductMeta__Description"); 
  if(prodouct_description){  
    var summaries = prodouct_description.querySelectorAll('summary'); // We need to add a wrapper to remove the outline when clicking on the summary.
    // This way there will still be an outline for keyboard users.
    if(summaries.length){
      for(var i=0;i<summaries.length;i++){  
        var summaryWrapper = document.createElement('div');
        summaryWrapper.setAttribute('tabindex', '-1');
        summaryWrapper.classList.add('summary-wrapper');
        summaryWrapper.innerHTML = summaries[i].innerHTML;
        summaries[i].innerHTML = '';

        summaries[i].appendChild(summaryWrapper);
      }
    }
  }

  var blogTagListSelect = document.querySelector('.Blog__TagList-select');
      if (blogTagListSelect != null) {
        blogTagListSelect.addEventListener('change', function () {
          window.location.href = this.value;
        });
      }
});

class MatchHeight {
  constructor($el, opts) {
    this.defaults = {
      timeout: 250
    };
    this.options = Object.assign(this.defaults, opts);
    this.$els = document.querySelectorAll($el);
    this.$elsArray = Array.prototype.slice.call(this.$els);
    this.getAndSet(this.$elsArray);
    this.debounceHeight = this.debounce(() => {
      this.getAndSet(this.$elsArray);
    }, this.options.timeout);
    window.addEventListener('resize', () => {
      this.debounceHeight();
    });
  }

  getAndSet($elsArray) {
    $elsArray.forEach($el => $el.removeAttribute('style'));
    const height = Math.max(...$elsArray.map(o => o.clientHeight));
    $elsArray.forEach(($el) => {
      Object.assign($el.style, { height: `${height}px`, verticalAlign: 'top' });
    });
  }

  debounce(func, wait, immediate) {
    let timeout;
    return () => {
      const context = this;
      const args = arguments;
      const later = () => {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      const callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }
}

document.addEventListener("DOMContentLoaded", function(event) {
  var coll_titles = document.querySelectorAll('.ProductItem .ProductItem__Title');
   if(coll_titles.length > 1){
    const matchHeight = new MatchHeight('.ProductItem .ProductItem__Title');
   }
   var ProductListCarousels = document.querySelectorAll('.ProductList--carousel.flickity-enabled');
   if(ProductListCarousels){
    ProductListCarousels.forEach(ProductListCarousel => {
//debugger;
      var flkty = Flickity.data(ProductListCarousel);
      flkty.resize();
    });
   }
  });
  
  document.addEventListener('variant:changed', function(event) {
    var variant = event.detail.variant; // Gives you access to the whole variant details

    console.log(variant);
    var klaviyo_trigger_btns = document.querySelectorAll('.klaviyo-bis-trigger');
    if(klaviyo_trigger_btns.length) {
      klaviyo_trigger_btns.forEach(function (klaviyo_trigger_btn,index) {
         if(variant.available) {
        klaviyo_trigger_btn.style.display = 'none';
      } else {
        klaviyo_trigger_btn.removeAttribute('style');
      }
      });
     
    }
    
  });


document.addEventListener("DOMContentLoaded", function() {



  var ProductForm__StickyButtonEl = document.querySelector('.ProductForm__StickyButton');
  if(ProductForm__StickyButtonEl) {
    function isElementInViewport (el) {
      if (typeof jQuery === "function" && el instanceof jQuery) {
        el = el[0];
      }

      var rect = el.getBoundingClientRect();
      let headerHeight = document.querySelector('#shopify-section-header').offsetHeight;

      return (
        rect.top >= headerHeight &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
        rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
      );
    }
    function checkStickyButtonPosition(el) {
      var window_width = window.innerWidth;
      if(window_width <= 640) {

        var ProductForm__BuyButtonsEl = document.querySelector('.ProductForm__BuyButtons .ProductForm__AddToCart');
        if(ProductForm__BuyButtonsEl) {
          console.log(isElementInViewport(ProductForm__BuyButtonsEl));
          if(isElementInViewport(ProductForm__BuyButtonsEl)) {
            el.classList.add('hide_button');
          } else {
            el.classList.remove('hide_button');
          }
        }
      }
    };
    checkStickyButtonPosition(ProductForm__StickyButtonEl);
    document.addEventListener('scroll', function(e) {
      checkStickyButtonPosition(ProductForm__StickyButtonEl);
    });

    document.addEventListener('click', function(e){
      var el = e.target;
      if(el.classList.contains('ProductForm__StickyButton') || el.closest('.ProductForm__StickyButton')) {
        if(!el.classList.contains('ProductForm__StickyButton')) {
          el = el.closest('.ProductForm__StickyButton');
        }

        e.preventDefault();
        
          var main_ATC_El = document.querySelector('.ProductForm__BuyButtons .ProductForm__AddToCart');
          if(main_ATC_El) {
            main_ATC_El.dispatchEvent(new Event('click', { bubbles: true }));
          }
        }
      
    });
  }
});

  window.onload = function() {
  if(document.getElementById('variant_oprtion_hidden')){
  var variant_attr = document.getElementById('variant_oprtion_hidden').getAttribute('data_hidden');
  if(variant_attr){
       document.getElementById('inner-notify').style.display = 'none';
  }
  }
};